import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import moment from "moment";

import { useUser, usePopup, useData, useMenu, useLang, useLoading, usePrompt } from "../zustand/store.js";

import { LangText } from "../zustand/dict.js";
import consts from '../libs/consts';
import images from "../libs/images"
import InputFileDrag from '../components/InputFileDrag';
import InputSimple from '../components/InputSimple.js';
import Button from '../components/Button';
import Selector from '../components/Selector';
import RadioImage from "../components/RadioImage";
import Radio from "../components/Radio";
import InputRange from "../components/InputRange";

import * as APIS from '../utils/service.js'
import Modal from "../components/Modal.js";
import { loadImage } from "../utils/utils.js";
import _ from "lodash";

// 영상 분위기 보정
export default function Menu10() {
    const navigate = useNavigate();
    const location = useLocation();

    const { menu, getMenu } = useMenu();
    const { country, getLang } = useLang();
    const { promptList, setPromptList } = usePrompt();

    const { bears, token, options, isReload, reload, setData, addABear } = useUser();
    const { open, title, popOpen, popClose } = usePopup();
    const { setLoading } = useLoading();

    const [config, setConifg] = useState({});
    const [configError, setConfigError] = useState(false);
    const [limitSize, setLimitSize] = useState(10000000000)

    const [prompt, setPrompt] = useState("");       // 프롬프트
    const [videoError, setVideoError] = useState(false);
    const [videoInfoError, setvideoInfoError] = useState(false);
    const [mediaInfo, setMediaInfo] = useState(null);

    const [presetIndex, setpresetIndex] = useState(0);
    const [ispresetUpload, setIspresetUpload] = useState(false);
    const [presetFile, setpresetFile] = useState(null); // 이미지 스타일 파일obj

    const [radio1, setRadio1] = useState(1);
    const [radio2, setRadio2] = useState(1);
    const [share, setShare] = useState(false);

    const [modal, setModal] = useState(consts.defaultModalValue)

    const [calcPoint, setCalcPoint] = useState(5);

    const randPrompt = () => {
        console.log(promptList.length);
        if (promptList.length > 0) {
            let selectIndex = _.random(promptList.length - 1)
            setPrompt(promptList[selectIndex]);
        }
    }

    const promptDataFunc = () => {
        APIS.post('/config/prompts').then(({ data }) => {
            setPromptList({
                key: "promptList",
                value: data
            })
        }).catch((e) => {
            console.log(e.response.data);
        });
    }

    // 비디오 만들기
    const makeVideoFunc = () => {
        let sendData = {
            prompt,
            preset: "",
            resolution: radio1,
            share: !share
        };

        if (!sendData.prompt) {
            setModal({
                ...modal,
                open: true,
                message: getLang({ key: "error_input_prompt" })
            })
            return;
        }

        sendData.preset = config.option_kart_style[presetIndex].idx
        console.log("sendData:", sendData);

        // setLoading(true)
        // setTimeout(() => { setLoading(false) }, 1000)
        // return;

        setLoading(true);
        APIS.post("/aiVideo/generator", sendData).then(({ data }) => {
            if (data) console.log("/aiVideo/generator:", data);
            setLoading(false);
            reload();
            navigate("/myart_history")
        }).catch((result) => {
            setLoading(false);
            let data = result.response.data;
            setModal({
                ...modal,
                open: true,
                message: getLang({ key: data.msgkey })
            })
        })
    }

    const defaultSetOption = (configData) => {
        let error = false

        if (error) setConfigError(error)

        if ("option_selector_text_video" in configData) {
            setRadio1(configData.option_selector_text_video[0]?.idx)
        } else {
            error = true
        }

        if (location.state?.artData) {
            setLoading(true)
            setTimeout(() => {
                setLoading(false)
                setLoadFunc(location.state?.artData, configData)
            }, 1000)
        }
    }

    const setLoadFunc = async (artData, configData) => {
        console.log("다시만들기")
        console.log("🚀 ~ setLoadPrec ~ artData:", artData)

        if (artData?.prompt) {
            setPrompt(artData?.prompt);
        }

        if (artData?.videoStyle) {
            let dataIndex = configData?.option_kart_style?.findIndex(v => v.value == artData?.videoStyle)
            if (dataIndex >= 0) {
                setpresetIndex(dataIndex)
            }
        }

        if (artData?.multipleOption) {
            console.log(configData?.option_selector_text_video, artData?.multipleOption)
            let data = configData?.option_selector_text_video?.find(v => v.value == artData?.multipleOption)
            if (data) {
                setRadio1(data.idx);
            }
        }
    }

    const configDataFunc = () => {
        APIS.post('/config/option').then(({ data }) => {
            setConifg(data);
            defaultSetOption(data);
        }).catch((e) => {
            console.log(e.response.data);
        });
    }

    useEffect(() => {
        promptDataFunc();
        configDataFunc();
    }, []);

    const modalConfirm = () => {
        if (modal.type === "test") {

        } else {
            modalClose();
        }
    }

    const modalClose = () => {
        setModal(consts.defaultModalValue)
    }

    return (
        <>
            <Modal
                open={modal.open}
                setOpen={(v) => {
                    setModal({ ...modal, open: v })
                }}
                title={modal.title}
                message={modal.message}
                onConfirm={modalConfirm}
                onCancel={modal.isClose ? () => { modalClose(); } : null}
            />

            <div className="content">
                <div className="title_box3">
                    <div className="text_area">
                        <p className="title">
                            <LangText id={getMenu({ idx: 10 })?.title_key} />
                        </p>
                        <p className="sub_title">
                            <LangText id={getMenu({ idx: 10 })?.info_key} />
                        </p>
                    </div>
                    <div className="thumb">
                        <img src={consts.imgUrl + getMenu({ idx: 10 })?.image?.[country]} />
                    </div>
                </div>

                <div className="setting_box">
                    {/* 프롬프트 작성 */}
                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_textvideo_prompt" /></p>
                                <p className="body1"><LangText id="info_textvideo_prompt" /></p>
                            </div>

                        </div>

                        <div className="option_box">
                            <div className="prompt_text_box">
                                <InputSimple
                                    className="border_none"
                                    value={prompt}
                                    setValue={setPrompt}
                                    maxlength={680}
                                    placeholder="Describe the video you want to generate."
                                />
                                <div className="or_box"><LangText id="text_or" /></div>
                                <Button
                                    image={images.generate_text_white}
                                    title={getLang({ key: "btn_random" })}
                                    type={3}
                                    onClick={randPrompt}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_kart_preset" /></p>
                                <p className="body1"><LangText id="info_kart_preset" /></p>
                            </div>

                            {/* <Button title={ispresetUpload ? getLang({ key: "btn_show_style" }) : getLang({ key: "btn_upload_image_style" })} type={2} onClick={() => {
                                setIspresetUpload(!ispresetUpload)
                            }} /> */}
                        </div>
                        {!ispresetUpload ? <div className="border_box">
                            <p className="body1"><LangText id="text_style_list" /></p>
                            <RadioImage
                                className="mt-12"
                                options={config?.option_kart_style?.map((v) => {
                                    return { title: getLang({ key: v?.title_key }), imgSrc: `${consts.imgUrl}${v?.imgPath}` }
                                })}
                                current={presetIndex}
                                onChange={setpresetIndex}
                                isLarge
                            />
                        </div> : <InputFileDrag
                            name="drag-file-style"
                            setValue={(v) => {
                                setpresetFile(v)
                            }}
                        />}
                    </div>

                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_kart_option" /></p>
                                <p className="body1"><LangText id="info_kart_option" /></p>
                            </div>
                        </div>
                        <div className="border_box">
                            <p className="body1 color-black">
                                <LangText id="text_option_resolution" />
                            </p>
                            <Radio
                                className="mt-12"
                                border={false}
                                value={radio1}
                                setValue={setRadio1}
                                options={config?.option_selector_text_video?.map((v) => {
                                    return { label: getLang({ key: v?.title_key }), value: v.idx }
                                })} />
                        </div>
                    </div>



                    <div className="confirm_box mt-80">
                        <Button
                            type={4}
                            title={getLang({ key: "btn_create_video", replace: { key: "{0}", val: calcPoint } })}
                            round
                            onClick={makeVideoFunc}
                        // disable={(video && !videoError && !videoInfoError) ? false : true}
                        />
                        <input
                            type="checkbox"
                            id={"checkShare"}
                            className='checkbox5'
                            // checked={false}
                            onChange={(e) => {
                                console.log(e.target.checked)
                            }} />
                        <label className="mt-12" for={'checkShare'}>
                            <LangText id="btn_not_share" />
                        </label>
                    </div>
                </div>
            </div>
        </>
    );
}
